// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__8QruV","blur":"Overlay_blur__Wws7l","side":"Overlay_side__ia1GY","sideBlock":"Overlay_sideBlock__Fc8TV","sideBlockSub":"Overlay_sideBlockSub__Dojdk"};